import { render, staticRenderFns } from "./CardBoard.vue?vue&type=template&id=0ff29a7a"
import script from "./CardBoard.vue?vue&type=script&lang=js"
export * from "./CardBoard.vue?vue&type=script&lang=js"
import style0 from "./CardBoard.vue?vue&type=style&index=0&id=0ff29a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports